export enum ProductClassifications {
  VoiceProduct = 'Voice',
  DataSim = 'DataSim',
  MBBProduct = 'MBB',
  Equipment = 'Equipment',
  Mobile = 'Mobile',
  TradeIn = 'TradeIn',
  ReturnBox = 'ReturnBox',
  CustomerServiceProduct = 'CustomerServiceProduct',
  Owner = 'Owner',
}
